let paginated_menu_template=`
<li class="actions">
    <a class="next">View More...</a>
</li>
<div class="dropdown paginated-menu">
  <button class="btn btn-default dropdown-toggle menu-title {{custom_attributes.button}}" 
        type="button" 
        data-toggle="dropdown" 
        aria-haspopup="true" 
        aria-expanded="true">
      <span class="text">Choose</span>
    <i class="fa fa-caret-down" style="float:right"></i>
  </button>
  <ul class="dropdown-menu children">
  </ul>
</div>`;

export default paginated_menu_template;
